<div id="contact-us-leaf" class="container-fluid ml-0">
    <h2 *ngIf="solutions?.length > 0" class="row mb-4 mt-4">Nous avons trouvé des solutions en ligne :</h2>

    <div *ngIf="solutions?.length > 0" class="row mb-4 solutions">
        <div id="solutionTitre" class="text col-12 col-md-12 col-lg-8 ml-0 py-3 mb-2">
            <span class="icon-info text-info"></span>
            <span class="solutionMessage">Vous avez la possibilité de gagner du temps en utilisant nos outils en ligne pour régler directement votre
        problème. Si les solutions proposées ne répondent pas à vos attentes, vous avez toujours la possibilité de nous
        contacter directement.</span
            >
        </div>
    </div>
    <div class="row">
        <ng-container *ngFor="let solution of solutions; let i = index">
            <div class="col-12 col-md-6 col-lg-4 pt-1">
                <div
                        id="{{ solution.type.valueOf() }}"
                        tabindex="0" role="button" aria-pressed="false"
                        class="solutionBox"
                        (click)="clicOnSolution(solution.type,solution.url)"
                >
                    <div class="my-1 ml-2">
                        <div class="solutionTitle d-flex justify-content-start">
                            <h6 class="mb-1 mb-lg-2">{{ getSolutionTitle(solution.type) }}</h6>
                        </div>
                        <div class="solutionText font-weight-normal text-start">
                            {{ solution.text }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <h2 *ngIf="contactEchat || contactPhone || contactEmail || contactCtc || contactDjingo" class="row mb-3 mt-4">
        Des questions ? Contactez-nous
    </h2>

    <div id="titreContact" class="row contact mb-4">

        <!--    Warning old version - url = echat_pro (live langage)/-->
        <a class="col-12 col-md-6 col-lg-4 mb-2 contact-color-white"
           *ngIf="contactEchat && contactEchat?.url !== 'echat_pro'"
           (click)="openEchat(getEchatReasonContact())">
            <div id="echat" class="contact-us-component" tabindex="0" role="button" aria-pressed="false">

                <div class="contact-label">
                    <div
                            id="titreEchat"
                            class="fw-bold"
                            *ngIf="segment2 !== 'need_someone_who_speaks_english'"
                    >
                        Par e-chat avec un conseiller<br/>
                    </div>
                    <div
                            id="titreEchatAnglais"
                            class="titreEchat fw-bold"
                            *ngIf="segment2 === 'need_someone_who_speaks_english'"
                    >
                        By e-chat with an advisor<br/>
                    </div>
                    <div class="autreInfo">{{ contactEchat.autreInfo }}</div>
                </div>
                <div class="contact-icon-format icon-Assistance"></div>
            </div>
        </a>

        <a class="col-12 col-md-6 col-lg-4 mb-2 contact-color-white"
           *ngIf="contactPhone" (click)="openPhone()">
            <div id="phone" class="contact-us-component"
                 tabindex="0" role="button" aria-pressed="false">
                <div class="contact-label"      >
                    <div
                            id="titrePhone"
                            class="fw-bold"
                            *ngIf="segment2 !== 'need_someone_who_speaks_english'"
                    >
                        Par téléphone avec un conseiller
                    </div>
                    <div
                            id="titrePhoneAnglais"
                            class="fw-bold"
                            *ngIf="segment2 === 'need_someone_who_speaks_english'"
                    >
                        By phone with an advisor
                    </div>
                </div>
                <div class="contact-icon-format icon-Icon"></div>
            </div>
        </a>
        <a class="col-12 col-md-6 col-lg-4 mb-2 contact-color-white"
           *ngIf="contactEmail" (click)="openEmail()">
            <div id="email" class="contact-us-component"
                 tabindex="0" role="button" aria-pressed="false">
                <div class="contact-label">
                    <div class="fw-bold">Ecrire à un conseiller<br/></div>
                </div>
                <div class="contact-icon-format icon-Email"></div>
            </div>
        </a>
        <a class="col-12 col-md-6 col-lg-4 mb-2 contact-color-black"
           aria-label="Demander à être rappelé"
           *ngIf="contactCtc" (click)="openCtc()">
            <div id="ctc" class="contact-us-component"
                 tabindex="0" role="button" aria-pressed="false"
            >
                <div class="contact-label">
                    <div class="fw-bold">Demander à être rappelé<br/></div>
                    <div class="autreInfo">{{ contactCtc.autreInfo }}</div>
                </div>
                <div class="contact-icon-format icon-Simple-mode"></div>
            </div>
        </a>
        <a class="col-12 col-md-6 col-lg-4 mb-2" *ngIf="contactDjingo"
           (click)="openDjingo()">
            <div id="djingo" class="contact-us-component pb-0"
                 tabindex="0" role="button" aria-pressed="false">
                <div class="djingo-icon">
                    <img class="" src="/contact-us/assets/avatar-djingo.svg" alt="djingo image"/>
                </div>
                <div class="px-3 contactLabel mt-0">
                    <div id="titreDjingo" class="fw-bold text-black pb-1">{{ contactDjingo.text }}</div>
                    <div id="texteDjingo" class="fw-bold text-black">{{ contactDjingo.text2 }}</div>
                </div>
            </div>
        </a>
    </div>

    <!-- Input 'Newton' pour passer le motif de contact -->
    <input *ngIf="contactEchat" id="newton_MotifContact" type="hidden" value="{{ getEchatReasonContact() }}"/>

    <!-- Formulaire d'email utilisé pour transmettre le motif de contact (email - nous écrire) -->
    <form
            *ngIf="contactEmail"
            id="formulaireEmail"
            method="{{ methodName }}"
            action="{{ contactEmail?.url }}"
            target="nouscontacter"
            style="display: none"
    >
        <input *ngIf="methodName ==='post'" type="hidden" id="email_MotifContact" name="email_MotifContact"
               value="{{ getMailReasonContact() }}"/>
        <input *ngIf="methodName ==='get'" type="hidden" id="email_MotifContact_get" name="{{ queryParam }}"
               value="{{ queryValue }}"/>
    </form>
</div>
